<path
    d="M1 1V49H49V1H1ZM45.8 45.8H4.19997V4.19997H45.7999V45.8H45.8Z"
    fill="currentColor"
/>
<path
    d="M12.8626 10.6H19.6668V7.40003H7.40015V19.6667H10.6001V12.8629L19.6022 21.8648L21.8647 19.6022L12.8626 10.6Z"
    fill="currentColor"
/>
<path
    d="M21.8648 30.3982L19.6022 28.1355L10.6001 37.1375V30.3333H7.40015V42.6H19.6668V39.4H12.8631L21.8648 30.3982Z"
    fill="currentColor"
/>
<path
    d="M39.3999 30.3333V37.1375L30.3978 28.1354L28.1353 30.3979L37.1369 39.4H30.3332V42.6H42.5999V30.3333H39.3999Z"
    fill="currentColor"
/>
<path
    d="M30.3332 7.40003V10.6H37.1374L28.1353 19.6022L30.3978 21.8648L39.3999 12.8629V19.6667H42.5999V7.40003H30.3332Z"
    fill="currentColor"
/>
